module.exports = __webpack_public_path__ + "img/pro_four_5.d1b9e70c.jpg";